export function noResultsSearchLinks (isAdmin) {
  let links = [];

  //filter-by = 2: backend value for search by comments
  //filter-by = 3: backend value for search by file names

  let url = '/orders';
  let params = {
    'filter-by': 2
  };

  if (isAdmin) url = '/admin/orders'

  links = [
    { url, type: 'comments', params: { 'filter-by': "comments" } },
    { url, type: 'files',  params: {'filter-by': "filenames"} }
  ];

  return links;
}

// todo wrap under if connector is active
export function handleMakeOrder(programId, name){
    $.ajax({
        type: "GET",
        url: APP_URL + '/programs/generate-order/' + programId
    })
        .then((res) => {
            window.location.replace(APP_URL + '/orders/view/' + res);
        });
}
